var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookGrayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9156 3.05017C18.9156 2.24749 18.6079 1.53846 17.9926 0.923077C17.3772 0.307692 16.6682 0 15.8655 0H3.50427C2.70159 0 1.99256 0.307692 1.37718 0.923077C0.761794 1.53846 0.454102 2.24749 0.454102 3.05017V15.4114C0.454102 16.214 0.761794 16.9231 1.37718 17.5385C1.99256 18.1538 2.70159 18.4615 3.50427 18.4615H9.68487V11.4783H7.43738V8.42809H9.68487V7.22408C9.68487 6.1806 10.026 5.26421 10.7083 4.47492C11.3906 3.68562 12.1999 3.29097 13.1364 3.29097H15.6247V6.34114H13.1364C13.0026 6.34114 12.8755 6.4214 12.7551 6.58194C12.6347 6.74248 12.5745 6.94314 12.5745 7.18395V8.42809H15.6247V11.4783H12.5745V18.4615H15.8655C16.6682 18.4615 17.3772 18.1538 17.9926 17.5385C18.6079 16.9231 18.9156 16.214 18.9156 15.4114V3.05017Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookGrayIcon);
export default __webpack_public_path__ + "static/media/FacebookGrayIcon.105ae2b8.svg";
export { ForwardRef as ReactComponent };